import { atom, useAtom } from 'jotai';

const pendingBankTransferModalOpenAtom = atom<boolean>(false);

export function usePendingBankTransferModal() {
  const [isOpen, setIsOpen] = useAtom(pendingBankTransferModalOpenAtom);

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
}
